<!-- =========================================================================================
    File Name: ChartBarChart.vue
    Description: Create bar chart
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card :title="settings.containerLabel" class="mb-base vx-col w-full md:w-1/2">
    <div class="mt-5">
      <chartjs-component-bar-chart :height="250" :data="data" :options="options"></chartjs-component-bar-chart>
    </div>

    <template slot="codeContainer"></template>
  </vx-card>
</template>

<script>
import ChartjsComponentBarChart from "./components/ChartjsComponentBarChart.vue";
export default {
  data() {
    return {
      data: {
        labels: this.settings.value.label,
        datasets: [
          {
            label: this.settings.barLabel,
            backgroundColor: this.settings.value.color,
            // backgroundColor: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
            data: this.settings.value.data
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: this.settings.chartLabel
        },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0, 
              }
            }
          ]
        }
      }
    };
  },
  props: {
    settings: Object,
    default: {}
  },
  components: {
    ChartjsComponentBarChart
  },
  created() {
    console.log("settings from horizontal:", this.settings);
    console.log("settings from horizontal:", this.settings.value.label);
  }
};
</script>
